import { writable } from "svelte/store";
import { tooltipStore, jsonStore } from "vpap/svelte/stores.js";

export const votingUnits = writable(undefined);
export const tooltip = tooltipStore();
export const activeData = jsonStore();
export const currentRound = writable(1);
